export default __webpack_public_path__ + "static/media/AppStore.09d88d10.svg";